import React from 'react';

export default function StudentCard({
    student,
    isArchived = false,
    copiedField,
    isAdmin,
    passwordInput,
    isPasswordLoading,
    onOpenDetails,
    onCopy,
    onArchiveToggle,
    onDelete,
    onPasswordInputChange,
    onPasswordChange
}) {
    const fullName = `${student.name} ${student.sname}`;

    return (
        <div className={`student-card ${isArchived ? 'archived-card' : ''}`}>
            <div className="student-header">
                <div className={`student-avatar ${isArchived ? 'archived-avatar' : ''}`}>
                    <svg viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                    </svg>
                </div>
                <div className="student-info">
                    <h3>{fullName}</h3>
                    <p className="student-phone">{student.phone}</p>
                    {isArchived && <span className="archived-badge">В архиве</span>}
                </div>
            </div>

            <div className="student-credentials">
                <div
                    className={`credential-field ${copiedField === `login-${student.public_key}` ? 'copied' : ''}`}
                    onClick={() => onCopy(student.public_key, `login-${student.public_key}`)}
                >
                    <span>Login: {student.public_key}</span>
                    {copiedField === `login-${student.public_key}` && (
                        <span className="copied-badge">Copied!</span>
                    )}
                </div>

                {isArchived && (
                    <div
                        className={`credential-field ${copiedField === `password-${student.public_key}` ? 'copied' : ''}`}
                        onClick={() => onCopy(student.password_key, `password-${student.public_key}`)}
                    >
                        <span>Password: {student.password_key}</span>
                        {copiedField === `password-${student.public_key}` && (
                            <span className="copied-badge">Copied!</span>
                        )}
                    </div>
                )}
            </div>

            <div className="student-actions">
                <button className="btn-secondary" onClick={() => onOpenDetails(student.public_key)}>
                    Подробнее
                </button>
                <button className="btn-archive" onClick={() => onArchiveToggle(student.public_key, fullName)}>
                    {isArchived ? 'Разархивировать' : 'Архивировать'}
                </button>
                <button className="btn-danger" onClick={() => onDelete(student.public_key, fullName)}>
                    Удалить
                </button>
            </div>

            {isAdmin && (
                <div className="password-change-box">
                    <input
                        type="password"
                        className="password-input"
                        placeholder="Новый пароль"
                        value={passwordInput || ''}
                        onChange={(e) => onPasswordInputChange(student.public_key, e.target.value)}
                    />
                    <button
                        className="btn-password-change"
                        onClick={() => onPasswordChange(student.public_key, fullName)}
                        disabled={isPasswordLoading}
                    >
                        {isPasswordLoading ? 'Сохраняем...' : 'Сменить пароль'}
                    </button>
                </div>
            )}
        </div>
    );
}
